package horcrux.common

enum class ServerAppRoute(val value: String) {
    CHAT_PAGE("chat-page"),
    CHAT_PAGES("chat-pages"),
    CHAT_PAGE_METADATA("chat-page-metadata"),
    COLLECTION("collection"),
    COLLECTIONS("collections"),
    DOCUMENT("document"),
    DOCUMENTS("documents"),
    DOCUMENT_URL("document-url"),
    FEEDBACK("feedback"),
    QUESTIONS("questions"),
    RAW_DOCUMENTS("raw-documents"),
    SCRIPTS("scripts");

    fun withSlash(): String = "/${this.value}"
}
